import React from 'react';
import { FaComments, FaClipboardList, FaBullseye, FaCog, FaRocket, FaDesktop, FaHeadset, FaCoffee } from 'react-icons/fa';
import './HowItWorks.css';

const HowItWorks = () => {
  const steps = [
    {
      id: 1,
      icon: <FaComments />,
      title: "Contact Us",
      description: "Reach out via any convenient channel — Telegram, WhatsApp, Discord, or email.",
      details: ["Quick response", "Multiple contact options"]
    },
    {
      id: 2,
      icon: <FaClipboardList />,
      title: "Share Details",
      description: "Tell us about your assessment requirements and we'll guide you through the process.",
      details: [
        "Exam type, date & time",
        "OR",
        "Interview/assessment platform (HireVue, Codility, etc.)",
        "Proctor name & type",
        "Your OS & setup"
      ],
      highlight: true
    },
    {
      id: 3,
      icon: <FaBullseye />,
      title: "Custom Solution Selection",
      description: "We individually select the best module (1, 2, or 3) for your specific situation.",
      details: [
        "🎯 Personalized module recommendation",
        "Instructions for your helper (AnyDesk/TeamViewer)",
        "Or we provide direct assistance"
      ],
      badge: "Individual Approach"
    },
    {
      id: 4,
      icon: <FaCog />,
      title: "Setup & Training",
      description: "Complete setup with full support and documentation before exam day.",
      details: [
        "Software installation & license activation",
        "We explain how not to get caught & proper behavior",
        "Learn the software ahead of time — relaxed, no last-minute stress",
        "📚 Full documentation included"
      ],
      badge: "24/7 Support",
      badgeIcon: <FaHeadset />
    },
    {
      id: 5,
      icon: <FaRocket />,
      title: "Exam Day Success",
      description: "Relax and let our solution do the work — your choice of assistance level.",
      details: [
        "☕ Module 3: Loop video & go drink tea while we handle it",
        "🎭 Or pretend you're working (appears natural)",
        "🔍 Or use Google/ChatGPT/any messenger yourself with full freedom"
      ],
      badge: "AFK Mode Available",
      badgeIcon: <FaCoffee />,
      highlight: true
    }
  ];

  return (
    <section className="how-it-works">
      <div className="how-container">
        
        {/* Header */}
        <div className="how-header">
          <h2 className="how-title">How It Works</h2>
          <p className="how-subtitle">Simple 5-step process from first contact to exam success</p>
        </div>

        {/* Timeline */}
        <div className="timeline">
          <div className="timeline-line"></div>
          
          {steps.map((step, index) => (
            <div 
              key={step.id} 
              className={`timeline-item ${index % 2 === 0 ? 'left' : 'right'} ${step.highlight ? 'highlight' : ''}`}
            >
              {/* Number Circle */}
              <div className="step-number">
                <span>{step.id}</span>
              </div>

              {/* Content Card */}
              <div className="step-card">
                <div className="step-icon">
                  {step.icon}
                </div>
                
                <h3 className="step-title">{step.title}</h3>
                
                {step.badge && (
                  <div className="step-badge">
                    {step.badgeIcon && <span className="badge-icon">{step.badgeIcon}</span>}
                    <span>{step.badge}</span>
                  </div>
                )}
                
                <p className="step-description">{step.description}</p>
                
                {step.details && step.details.length > 0 && (
                  <ul className="step-details">
                    {step.details.map((detail, idx) => (
                      <li key={idx}>{detail}</li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default HowItWorks;
